import { queryClient } from '@/config/queryClient';
import { EPISODE_PRESENTATIONS_ROOT, EPISODES_ROOT } from '@/data/entities/episodes';
import { PROJECTS_ROOT } from '@/data/entities/projects';

export const deleteCommentInTextAtomContent = (textAtomContent: string, commentId: number) => {
    // update textAtom of text
    const div = document.createElement('div');
    div.innerHTML = textAtomContent;

    const commentElement = div.querySelector<HTMLElement>(`[data-type="comment"][data-id="${commentId}"]`);
    if (commentElement) {
        // comment is still in the text
        const { childNodes } = commentElement;
        if (childNodes.length) {
            commentElement.replaceWith(...childNodes);
        } else {
            commentElement.remove();
        }
    }

    return div.innerHTML;
};

export const clearCommentsInTextAtomContent = (textAtomContent: string) => {
    // update textAtom of text
    const div = document.createElement('div');
    div.innerHTML = textAtomContent;

    const commentElements = div.querySelectorAll<HTMLElement>(`[data-type="comment"]`);
    Array.from(commentElements).forEach(commentElement => {
        if (commentElement) {
            // comment is still in the text

            const { innerHTML } = commentElement;
            if (innerHTML) {
                commentElement.replaceWith(innerHTML);
            } else {
                commentElement.remove();
            }
        }
    });

    return div.innerHTML;
};

export const clearSearchInTextAtomContent = (textAtomContent: string) => {
    // update textAtom of text
    const div = document.createElement('div');
    div.innerHTML = textAtomContent;
    const searchElements = div.querySelectorAll<HTMLElement>(`[data-type="search"]`);

    Array.from(searchElements).forEach(searchElement => {
        if (searchElement) {
            // search is still in the text
            const { textContent } = searchElement;
            if (textContent) {
                searchElement.replaceWith(textContent);
            } else {
                searchElement.remove();
            }
        }
    });

    return div.textContent;
};

export const getCommentIdsAsInTextAtomContent = (textAtomContent: string) => {
    const div = document.createElement('div');
    div.innerHTML = textAtomContent;

    const commentElements = div.querySelectorAll<HTMLElement>(`[data-type="comment"]`);

    return Array.from(commentElements).map(commentElement => Number(commentElement.dataset.id));
};

export const textableTypeToTextableModel = (textableType = '') => (textableType.split('\\').pop() as string).toLowerCase();

export const invalidateAfterCommentUpdate = (_episode_id: number | null) => () => {
    queryClient.invalidateQueries({ queryKey: PROJECTS_ROOT });
    queryClient.invalidateQueries({ queryKey: EPISODES_ROOT });
    queryClient.invalidateQueries({
        queryKey: EPISODE_PRESENTATIONS_ROOT,
    });
    queryClient.invalidateQueries({ queryKey: ['scenes'] });
};

export const removeMarksFromString = (inputString: string | null, dataIdsToRemove: string[]) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = inputString || '';

    dataIdsToRemove.forEach(dataId => {
        const marks = tempDiv.querySelectorAll(`mark[data-id="${dataId}"]`);
        marks.forEach(mark => {
            const textNode = document.createTextNode(mark.textContent || '');
            mark.parentNode?.replaceChild(textNode, mark);
        });
    });

    return tempDiv.innerHTML;
};

export const findRemovedMarkIds = (originalText: string, editedText: string) => {
    function extractMarkIds(htmlString: string) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        const marks = tempDiv.querySelectorAll('mark');

        const firstMark = marks[0];
        if (marks.length === 1 && firstMark && firstMark.textContent?.length === 0) {
            return Array.from(firstMark.id);
        } else {
            return Array.from(marks).map(mark => mark.getAttribute('data-id')) as string[];
        }
    }

    const originalMarkIds = extractMarkIds(originalText);
    const editedMarkIds = extractMarkIds(editedText);

    return originalMarkIds.filter(id => !editedMarkIds.includes(id));
};
